import React, { useMemo } from 'react'
import dayjs from 'dayjs'

import './style.scss'
import RegistrationHelper from 'general/helpers/RegistrationHelper'
import Utils, { getTaxCodeCompany } from 'general/utils/Utils'

function Message109(props) {
  const { message } = props
  console.log('message', message)
  const isSent = useMemo(() => message.messageId?.startsWith('V'), [message])
  const TGGui = useMemo(
    () => message.contentRaw?.TDiep?.TTChung?.TGGui,
    [message],
  )

  return (
    <div className="Message100 border-bottom mb-5">
      <div className="d-flex flex-row">
        <div style={{ maxWidth: '500px' }}>
          <p className="mb-2">
            <span
              style={{
                width: '18px',
                height: '18px',
                backgroundColor: '#1877F2',
                textAlign: 'center',
                borderRadius: '100%',
                marginRight: '6px',
                display: 'inline-flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <i
                className={`fa-regular ${
                  isSent ? 'fa-arrow-up' : 'fa-arrow-down'
                }  text-white  `}
                style={{
                  fontSize: '12px',
                }}
              ></i>
            </span>
            <span className="text-time">
              {TGGui && dayjs(TGGui).format('DD/MM/YYYY hh:mm:ss')}
            </span>
          </p>

          <p className="mb-2">
            {`[${
              message.typeCode
            }] ${RegistrationHelper.renderRegistrationTypeCode(
              message.typeCode,
            )}`}
          </p>

          <p className="mb-2" style={{ color: '#c4c4c4' }}>
            {`Mã thông điệp: ${message.messageId}`}
          </p>
        </div>
        <div className="text-right flex-fill">
          <p className="mb-2 font-weight-bold">
            {isSent
              ? getTaxCodeCompany(process.env.REACT_APP_SEARCH_PAGE_URL)
              : 'Cơ quan thuế'}
          </p>

          <p className="mb-2">
            <span
              style={{
                fontWeight: '500',
                fontSize: '13.2px',
                lineHeight: '16px',
                borderRadius: '10px',
                backgroundColor: /* '#e0e0e0' : */ '#E5F1E8',
                color: /* '#666666' : */ '#20A144',
                padding: '4px 10px',
              }}
            >
              Đã gửi CQT
            </span>
          </p>

          <p
            className="mb-2 cursor-pointer"
            onClick={() =>
              Utils.exportXmlFile({
                data: message.contentRaw.TDiep.DLieu.XML,
                fileName: 'thong-diep-109',
                _parse: false,
              })
            }
            title="Xuất khẩu XML"
          >
            <i
              className="fa-regular fa-download"
              style={{ color: 'inherit' }}
            ></i>
          </p>
        </div>
      </div>
    </div>
  )
}

export default Message109
